export const accent = '#f90000';

export const primaryText = '#161514';
export const theme = '#EF4051';

export const darkBlue = '#2C2E3A';
export const offWhite = '#F5F5F5';
export const grey = '#E5E9EB';
export const subtleGrey = '#EBEBF2';
export const lightGrey = '#d3d3d3';
export const almostBlack = '#010101';

export const gradStart = '#3faffd';
export const gradMid = '#259dfc';
export const gradEnd = '#6e56d7';

export const gradGoldStart = '#F1D39E';
export const gradGoldEnd = '#9D804B';

export const redGradStart = '#EF4051';
export const redGradEnd = '#F24327';
// export const redGradEnd = '#FF6037';

// Border radius
export const brNorm = '3rem';
export const brInner = '2rem';

// Spacing
export const rhythm = '2.5rem';
